module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1034.9519dc57.png";